import React from 'react';
import store from 'store';
import { Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Container, Row, RowChild } from 'styles';
import { StandardRow } from 'components/standard-row';
import { HeadingAndText } from 'components/heading-and-text';
import { useSessionContext } from 'contexts/session';
import { useAccountContext } from 'contexts/account';
import {
  getUtilityCredentialSubLabel,
  isApiTokenUtility,
  UTILITY_CREDENTIAL_ID_FOR_SYNC,
} from 'domain/utility-credentials';
import { UtilityCredentialConnectButton } from '../utility-credential-connect-button';

const getCopy = copyFor('settings.utilitySync');

interface Props {
  utilityCredential: GetUtilitySyncCredentialDataQuery['utilityCredential'];
}

export const SyncItem = ({ utilityCredential }: Props) => {
  const { userId } = useSessionContext();
  const { language, selectedAccountId } = useAccountContext();
  const { utility } = utilityCredential;
  const utilityName = utility?.displayName;

  const loginLabelText = getCopy('utilityLoginLabel', { utilityName });
  const loginLabel = (
    <Text tag="h3" textStyle="heading500">
      {loginLabelText}
    </Text>
  );
  const storeUtilityCredentialId = () => {
    store.set(UTILITY_CREDENTIAL_ID_FOR_SYNC, utilityCredential.id);
  };
  const isIncorrectVerification =
    utilityCredential.verificationStatus === 'incorrect';
  const warningMessage = isIncorrectVerification
    ? getCopy('warningText')
    : null;

  return !isApiTokenUtility(utility) ? (
    <Row>
      <RowChild alignItems="flex-start" xsmall={{ direction: 'column' }}>
        <HeadingAndText
          heading={loginLabel}
          text={getUtilityCredentialSubLabel({ utilityCredential })}
          warning={warningMessage}
        />
        <Container
          flex
          margin={{ left: '24px' }}
          xsmall={{ margin: { left: '0', top: '8px' } }}
        >
          <UtilityCredentialConnectButton
            utilityCredentialId={utilityCredential.id}
            userName={utilityCredential.username}
            userId={userId}
            accountId={selectedAccountId}
            language={language}
          />
        </Container>
      </RowChild>
    </Row>
  ) : (
    <StandardRow
      heading={loginLabel}
      text={getUtilityCredentialSubLabel({ utilityCredential })}
      iconLinkProps={{
        ariaLabel: loginLabelText,
        onClick: storeUtilityCredentialId,
        to: routes().utilitySyncEdit,
      }}
    />
  );
};
